<template>
    <tg-dialog
        ref="dialog"
        :title="title"
        v-bind="{ ...$attrs }"
        v-on="$listeners"
        :visible.sync="visible"
        :showIcon="false"
        :showFooter="true"
        :showCancelBtn="true"
        :confirmLabel="confirmLabel"
        :cancelLabel="cancelLabel"
        width="35%"
        @on-confirm="handleConfirm"
        @on-cancel="handleCancel"
        :disableConfirmBtn="checkBoxClear"
        :confirmBtnClass="confirmBtnClass"
        class="tg-member-privilege-bulk-dialog"
    >
        <el-row type="flex" justify="start" align="middle" >
            <el-checkbox-group v-model="merchantData">
                <template v-for="item in merchantList">
                    <el-checkbox
                        :label="item.text"
                        :key="item.text"
                        @change="handleChange()"
                        :style="{width:maxLabelWidth+'px'}"
                    >
                        {{item.text}}
                    </el-checkbox>
                </template>
            </el-checkbox-group>
        </el-row>
    </tg-dialog>
</template>

<script>
// import apis from "@/apis";
import TgDialog from "@/components/dialog/TgDialog";

export default {
    inheritAttrs: false,
    components: {
        TgDialog,
    },
    data() {
        return {
            merchant:[],
            visible: false,
            response: [],
            maxLabelWidth: 100,
            selectAll:true,
        };
    },
    props: {
        merchantData: Array,
        merchantList: Array,
        isNotAccount: Boolean,
    },
    computed: {
        title() {
            return this.$t("component.btn.merchant_choose");
        },
        confirmLabel() {
            return this.$t("component.btn.confirm");
        },
        cancelLabel() {
            if(this.checkBoxClear){
                return this.$t("component.btn.all");
            }else{
                return this.$t("component.btn.clear");
            }
        },
        selected() {
            return this.merchantData;
        },
        checkBoxClear(){
            return this.selected.length == 0;
        },
        confirmBtnClass(){
            if(this.checkBoxClear){
                return [];
            }else{
                return ['confirm'];
            }
        },
    },
    created() {
        // this.merchant = this.merchantList ;
        this.merchantList.forEach(element=>{
            this.merchantData.push(element.text);
        });

        this.$emit("on-click", this.selected);
    },
    methods: {
        showDialog() {
            this.visible = true;
        },
        handleConfirm() {
            let selected = [];
            if(this.selected.length != 0){
                selected = this.merchantData;
            }
            this.$emit("on-click", selected);
        },
        handleCancel(e) {
            e.preventDefault = true;
            if(this.checkBoxClear){
                let array = [];
                this.merchantList.forEach(element=>{
                    array.push(element.text);
                });
                this.merchantData = array;
            }else{
                this.merchantData = [];
            }
        },
        handleChange() {
            if (this.merchantData.length ==
                this.merchantList.length
            ) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },
    },
};
</script>
